import React from 'react'
import { useTranslation } from 'react-i18next'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { SelectCallback } from '../../../utils/types/UICommonTypes'
interface TabDetail {
  key: number
  eventKey: string
  icon: React.ReactElement | null
  title: string
  disabled: boolean
  tooltip: string
}

interface ATTabsProps {
  tabDetails: TabDetail[]
  onTabSelect: (eventKey: string) => void
  showIcon?: boolean
  activeKey: string
}
const ATTabs: React.FC<ATTabsProps> = ({
  tabDetails,
  onTabSelect,
  showIcon = false,
  activeKey,
}) => {
  const [key, setKey] = React.useState(tabDetails[0].eventKey)
  const { t } = useTranslation(['translation'])
  const onSelectHandler: SelectCallback = (eventKey, e) => {
    if (eventKey !== null) {
      setKey(eventKey)
      onTabSelect(eventKey)
    } else {
      setKey(tabDetails[0].eventKey)
    }
  }

  return (
    <Tabs
      variant="tabs"
      activeKey={activeKey || key}
      id="applicationTab"
      onSelect={onSelectHandler}
    >
      {tabDetails.map((tabDetail) => {
        const icon = tabDetail.icon ? (
          <span className="tab-icon">{tabDetail.icon}</span>
        ) : (
          ''
        )
        return (
          <Tab
            key={tabDetail.key}
            eventKey={tabDetail.eventKey}
            aria-label={t(tabDetail.title)}
            className="d-flex justify-content-start"
            title={
              <span className="text-uppercase  d-flex flex-column align-items-center align-self-center">
                <div className="d-flex flex-row">
                  {showIcon && <span title={t(tabDetail.title)}>{icon}</span>}

                  <OverlayTrigger
                    key={tabDetail.eventKey}
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-${tabDetail.title}`}>
                        {t(tabDetail?.tooltip)
                          ? t(tabDetail?.tooltip)
                          : t(tabDetail.title)}
                      </Tooltip>
                    }
                  >
                    <span className={showIcon ? 'px-1' : ''}>
                      {t(tabDetail.title)}
                    </span>
                  </OverlayTrigger>
                </div>
              </span>
            }
            disabled={tabDetail?.disabled}
          ></Tab>
        )
      })}
    </Tabs>
  )
}

export default ATTabs
